import { render, staticRenderFns } from "./bottomInfo.vue?vue&type=template&id=00e20f41&"
import script from "./bottomInfo.vue?vue&type=script&lang=js&"
export * from "./bottomInfo.vue?vue&type=script&lang=js&"
import style0 from "./bottomInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports